/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import React from 'react'
import ScrollIntoViewIfNeeded from 'DesignSystem/ScrollIntoViewIfNeeded/react'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Steps/Content/Step/Reference/Content"
  
}) {
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<ScrollIntoViewIfNeeded
  viewPath={`${viewPath}/ScrollIntoViewIfNeeded`}
 scrollMode="always"
 block="start"
 inline="start"
 behavior={isMedia.mobile ? "auto" : "smooth"}
/>
{children}
</React.Fragment>)
}